// extracted by mini-css-extract-plugin
export default {"btn":"LogoutBtn_btn__nVqua"};